import { IBaseAction, ERRORS } from '../../constants';

export interface ObjectType { }

export const errorMaps: ObjectType = ERRORS;

export interface CityNamesType {
    value: any;
    label: any;
    type?: string;
}

export interface FlightDuration {
    airplaneType: string;
    duration: number;
}

export interface City {
    name: string;
    alias: string;
    flightDurations: Array<FlightDuration>;
}

export interface CityListState {
    data: City[];
    total: 0;
}

export interface CitiesInfoInitialState {
    cities: Array<City>;
}

export const CITIES_INFO = 'CITIES_INFO';
export const CITIES_INFO_SUCCESS = 'CITIES_INFO_SUCCESS';
interface GetCitiesInfoAction extends IBaseAction {
    type: typeof CITIES_INFO | typeof CITIES_INFO_SUCCESS;
    payload?: {
        data: CitiesInfoInitialState;
    };
}

export interface FlightRequest { }

export interface FlightType {
    name: string;
    alias: string;
}

export interface FlightTypeListState {
    data: FlightType[];
    total: 0;
}

export interface FlightTypesInfoInitialState {
    flightTypes: Array<string>;
}

export const FLIGHT_TYPES_INFO = 'FLIGHT_TYPES_INFO';
export const FLIGHT_TYPES_INFO_SUCCESS = 'FLIGHT_TYPES_INFO_SUCCESS';
interface GetFlightTypesInfoAction extends IBaseAction {
    type: typeof FLIGHT_TYPES_INFO | typeof FLIGHT_TYPES_INFO_SUCCESS;
    payload?: {
        data: FlightTypesInfoInitialState;
    };
}

export interface ConfirmOfferFlightRequestInitialState { }
export const CONFIRM_OFFER_FLIGHT_REQUEST = 'CONFIRM_OFFER_FLIGHT_REQUEST';
export const CONFIRM_OFFER_FLIGHT_REQUEST_SUCCESS = 'CONFIRM_OFFER_FLIGHT_REQUEST_SUCCESS';
export const CONFIRM_OFFER_FLIGHT_REQUEST_FAILURE = 'CONFIRM_OFFER_FLIGHT_REQUEST_FAILURE';
export const CONFIRM_OFFER_FLIGHT_REQUEST_CLEAR = 'CONFIRM_OFFER_FLIGHT_REQUEST_CLEAR';
export const CHANGE_ROUTE = 'CHANGE_ROUTE';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export interface ConfirmOfferFlightRequestAction extends IBaseAction {
    type:
    | typeof CONFIRM_OFFER_FLIGHT_REQUEST
    | typeof CONFIRM_OFFER_FLIGHT_REQUEST_SUCCESS
    | typeof CONFIRM_OFFER_FLIGHT_REQUEST_FAILURE
    | typeof CONFIRM_OFFER_FLIGHT_REQUEST_CLEAR;
    payload?: {
        data: ConfirmOfferFlightRequestInitialState;
    };
}

export interface AirlineFinalRejectFlightRequestInitialState { }
export const AIRLINE_FINAL_REJECT_FLIGHT_REQUEST = 'AIRLINE_FINAL_REJECT_FLIGHT_REQUEST';
export const AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_SUCCESS = 'AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_SUCCESS';
export const AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_FAILURE = 'AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_FAILURE';
export const AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_CLEAR = 'AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_CLEAR';
export interface AirlineFinalRejectFlightRequestAction extends IBaseAction {
    type:
    | typeof AIRLINE_FINAL_REJECT_FLIGHT_REQUEST
    | typeof AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_SUCCESS
    | typeof AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_FAILURE
    | typeof AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_CLEAR;
    payload?: {
        data: AirlineFinalRejectFlightRequestInitialState;
    };
}

export interface AirlineRequestAfterRejectionInitialState { }
export const AIRLINE_REQUEST_AFTER_REJECTION = 'AIRLINE_REQUEST_AFTER_REJECTION';
export const AIRLINE_REQUEST_AFTER_REJECTION_SUCCESS = 'AIRLINE_REQUEST_AFTER_REJECTION_SUCCESS';
export const AIRLINE_REQUEST_AFTER_REJECTION_FAILURE = 'AIRLINE_REQUEST_AFTER_REJECTION_FAILURE';
export const AIRLINE_REQUEST_AFTER_REJECTION_CLEAR = 'AIRLINE_REQUEST_AFTER_REJECTION_CLEAR';
export interface AirlineRequestAfterRejectionAction extends IBaseAction {
    type:
    | typeof AIRLINE_REQUEST_AFTER_REJECTION
    | typeof AIRLINE_REQUEST_AFTER_REJECTION_SUCCESS
    | typeof AIRLINE_REQUEST_AFTER_REJECTION_FAILURE
    | typeof AIRLINE_REQUEST_AFTER_REJECTION_CLEAR;
    payload?: {
        data: AirlineRequestAfterRejectionInitialState;
    };
}

export interface Flight {
    type: string;
    airline: string;
    flightId?: string;
    uniqueId?: string;
    incoming?: boolean;
    twoWay?: boolean;
    goingWay?: boolean;
    comingWay?: boolean;
    source: string;
    destinations: string[];
    flightNumber: string;
    register?: string;
    airplaneType: string;
    nightStay?: boolean;
    startDate: Date;
    endDate: Date;
    rangeStartDate?: Date;
    rangeEndDate?: Date;
    baseStartDate?: Date;
    baseEndDate?: Date;
    baseDepartureTime?: Date;
    baseEntranceTime?: Date;
    entranceTime?: Date;
    departureTime?: Date;
    requestNumber: string;
    multipleRoutes?: boolean;
    daysOfWeek?: number[];
    confirmed?: boolean;
    rejected?: boolean;
    offer?: boolean;
    status: string;
    newEndDate?: Date;
    newStartDate?: Date;
    newEntranceTime?: Date;
    newDepartureTime?: Date;
    ranges?: any[];
    overnight?: boolean;
}

export interface FlightRequest {
    type: string;
    type_desc?: string;
    summerSeason?: any;
    airline: string;
    airlineLogo: string;
    flights: Flight[];
    generatedFlights: Flight[];
    monitoringNumber?: string;
    status: string;
    instanceId: string;
    taskId: string;
    monitoringNumberFile?: string;
    rejectionDescription?: string;
    reasonsOfRejection?: string[];
    updatedAt?: Date;
    requesterName?: string;
}

export interface FlightRequestsState {
    data: FlightRequest;
}

export interface FlightRequestInitialState {
    flightRequest: FlightRequest;
}
export const GET_FLIGHT_REQUEST = 'GET_FLIGHT_REQUEST';
export const GET_FLIGHT_REQUEST_SUCCESS = 'GET_FLIGHT_REQUEST_SUCCESS';
export const GET_FLIGHT_REQUEST_CLEAR = 'GET_FLIGHT_REQUEST_CLEAR';
interface GetFlightRequestsList extends IBaseAction {
    type: typeof GET_FLIGHT_REQUEST | typeof GET_FLIGHT_REQUEST_SUCCESS | typeof GET_FLIGHT_REQUEST_CLEAR;
    payload: {
        data: FlightRequestInitialState;
    };
}

export const EMPTY_FIELDS = 'EMPTY_FIELDS';
export const FIRST_CONFIRM_MONITORING = 'FIRST_CONFIRM_MONITORING';
export const CONFIRMED_MONITORING = 'CONFIRMED_MONITORING';
export const FLIGHT_REQUEST_CREATED = 'FLIGHT_REQUEST_CREATED';

export type FlightRequestActionTypes =
    | GetCitiesInfoAction
    | AirlineFinalRejectFlightRequestAction
    | ConfirmOfferFlightRequestAction
    | GetFlightTypesInfoAction
    | AirlineRequestAfterRejectionAction
    | GetFlightRequestsList;
